import type { MiddlewareFunction } from 'react-router';

import type { FeatureGateKeys } from '@trello/feature-gates';

import { isGateEnabled } from './isGateEnabled';

const noopMiddleware: MiddlewareFunction = () => {};

/**
 * Load the provided middleware only if the specified feature gate is enabled.
 */
export const loadMiddlewareIfGateEnabled = (
  featureGate: FeatureGateKeys,
  middleware: MiddlewareFunction,
): MiddlewareFunction => {
  const shouldLoad = isGateEnabled(featureGate);
  return shouldLoad ? middleware : noopMiddleware;
};
